<template>
  <div v-if="!isInIframe" class="cookie-manager">
    <CookieBanner
      v-if="!isSettingsOpen"
      @open-settings="isSettingsOpen = true"
    />
    <CookieSettings
      :is-open="isSettingsOpen"
      @close-and-return="isSettingsOpen = false"
      @saved="isSettingsOpen = false"
    />
  </div>
</template>

<script>
import CookieBanner from "./CookieBanner.vue";
import CookieSettings from "./CookieSettings.vue";
import { eventBus } from "@/main";

export default {
  name: "CookieManager",
  components: {
    CookieBanner,
    CookieSettings,
  },
  data() {
    return {
      isSettingsOpen: false,
      isInIframe: false,
    };
  },
  created() {
    try {
      this.isInIframe = window.self !== window.top;
    } catch (e) {
      this.isInIframe = true;
    }

    eventBus.$on("openCookieBanner", this.handleOpenSettings);
  },

  beforeDestroy() {
    eventBus.$off("openCookieBanner", this.handleOpenSettings);
  },

  methods: {
    handleOpenSettings() {
      this.isSettingsOpen = true;
    },
  },
};
</script>
